module.exports = __webpack_public_path__ + "img/重庆巴山湖国家湿地公园@2x.2673b34f.png";